/* eslint-disable max-lines-per-function */
import { isMobile } from "common/utils/browser";
import initSlider from "common/utils/ui/slider";
import initCable from "common/jiffy/pdp-comparables-messages";
import { initBadges } from "components/jiffy/j1-badge/j1-badge-popup/j1-badge-popup";
import initSoftnessScore from "components/compositions/softness_score/component";
import "./product-card-comparisons.scss";
import "./product-card-comparisons-item/product-card-comparisons-item.scss";

const SELECTORS = {
  SWATCH: ".js-comparables-swatch",
  POPUP: ".js-similar-swatch-popup",
  CLOSE: ".js-similar-swatch-close",
  COLOR_CELL: "product-card-comparables__color",
  PRODUCT_DETAILS: ".js-product-details",
  JFIRST_POPUP: ".js-jiffy-first-badge-popup",
  ESTIMATES_WRAPPER: ".js-delivery-date-estimates-comparables-wrapper",
  SIZES_LIST: ".js-sizes-list"
};

const initScroll = parent => {
  if (isMobile()) {
    return false;
  }

  return initSlider({
    parent,
    list: ".js-similar-list",
    grid: ".js-similar-grid",
    arrowLeft: ".js-similar-scroll-left",
    arrowRight: ".js-similar-scroll-right",
    hiddenClass: "product-details-similar-products__arrow-disabled"
  });
};

const isElementVisible = el => {
  const rect = el.getBoundingClientRect();
  const vWidth = window.innerWidth || document.documentElement.clientWidth;
  const vHeight = window.innerHeight || document.documentElement.clientHeight;
  const efp = (x, y) => document.elementFromPoint(x, y);

  // Return false if it's not in the viewport
  if (rect.right < 0 || rect.bottom < 0 || rect.left > vWidth || rect.top > vHeight) return false;

  // Return true if any of its four corners are visible
  return (
    el.contains(efp(rect.left, rect.top)) ||
    el.contains(efp(rect.right, rect.top)) ||
    el.contains(efp(rect.right, rect.bottom)) ||
    el.contains(efp(rect.left, rect.bottom))
  );
};

const getCompositionIds = rows =>
  Array.from(rows)
    .filter(cell => cell.dataset.assignable === "true")
    .map(elem => elem.dataset.compositionId);

const sliderHandler = () => {
  setTimeout(() => {
    const { App } = window;
    const estimatesRows = document.querySelectorAll(SELECTORS.ESTIMATES_WRAPPER);

    const visibleRows = Array.from(estimatesRows).filter(element => isElementVisible(element));
    let compositionIds = getCompositionIds(visibleRows);

    if (compositionIds.length > 0) {
      // ensure we send each composition once
      compositionIds = compositionIds.filter(
        id => !window.comparablesCompositionIdsSent.includes(id)
      );

      if (compositionIds.length > 0) {
        App.comparablesDatesChannel.send({ composition_ids: compositionIds });
      }
    }
  }, 500);
};

const initSliderHandlers = () => {
  Array.from(document.querySelectorAll(".js-similar-scroll-left")).forEach(e =>
    e.addEventListener("click", sliderHandler)
  );
  Array.from(document.querySelectorAll(".js-similar-scroll-right")).forEach(e =>
    e.addEventListener("click", sliderHandler)
  );
  document.querySelector(".js-similar-list").addEventListener("scroll", sliderHandler);
};

const areEstimatesShown = () => {
  const showComparablesDeliveryEstimates =
    document.querySelector(".js-product-details")?.dataset?.showComparablesDeliveryEstimates;

  const showFavoriteComparablesDeliveryEstimates = document.querySelector(
    ".js-account-favorite-items"
  )?.dataset?.showFavoriteComparablesDeliveryEstimates;

  return (
    showComparablesDeliveryEstimates === "true" ||
    showFavoriteComparablesDeliveryEstimates === "true"
  );
};

export default () => {
  initScroll();
  initBadges();
  initSoftnessScore();

  if (areEstimatesShown()) {
    const $estimatesRows = document.querySelectorAll(SELECTORS.ESTIMATES_WRAPPER);
    const compositionIds = getCompositionIds($estimatesRows);

    // send first 6 compositions on init
    const initialIds = compositionIds.slice(0, 6);
    const connectionId = new Date().getTime();
    initCable(connectionId, initialIds);
    initSliderHandlers();
  }

  const $swatches = document.querySelectorAll(SELECTORS.SWATCH);
  const $jiffyFirstPopup = document.querySelector(SELECTORS.JFIRST_POPUP);
  const $sizesList = document.querySelectorAll(SELECTORS.SIZES_LIST);

  const heightList = Array.from($sizesList).map($node => $node.offsetHeight);
  const maxHeight = Math.max(...heightList);
  $sizesList.forEach($node => {
    // eslint-disable-next-line no-param-reassign
    $node.style.height = `${maxHeight}px`;
  });

  if (!$swatches.length) {
    const colorCells = document.querySelectorAll(`.${SELECTORS.COLOR_CELL}`);

    colorCells.forEach(cell => {
      cell.classList.remove(SELECTORS.COLOR_CELL);
    });

    return;
  }

  $swatches.forEach(swatch => {
    const popup = swatch.parentNode.querySelector(SELECTORS.POPUP);
    const closeBtn = swatch.parentNode.querySelector(SELECTORS.CLOSE);

    swatch.addEventListener("click", () => {
      if (!isMobile()) return;

      popup.classList.add("show");

      if ($jiffyFirstPopup) {
        $jiffyFirstPopup.classList.remove("open");
      }
    });

    closeBtn.addEventListener("click", () => {
      popup.classList.remove("show");
    });
  });
};
